import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';

@Injectable()
export class CommonDbService {

    constructor(private _http: HttpClient,
                private config: Configuration,
                public ionicAngular4Cache: IonicAngular4CacheService) { }

    public getFeed(ids: any, skip: Number, limit: Number) {
        const timelineObs = this._http.post(`${this.config.ServerApiUrl}/timeline/read`,
         {status:'Published', ids:ids, skip: skip, limit: limit});
         timelineObs.subscribe(data => {
            this.ionicAngular4Cache.saveItemOld(`timeline`, data);
         }, error => {});
         return timelineObs;
    }

    public saveFile(data){
        return this._http.post(`${this.config.ServerApiUrl}/timeline/saveImage`,data);
    }
}
